import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const MediaPlans = () => {
    const [mobileNavOpen, setMobileNavOpen] = useState(false);

    return (
        <div className="bg-white text-slate-900 font-sans">
            <style>
                {`
          .glass { backdrop-filter: blur(10px); background: rgba(255,255,255,.82); }
          .shadow-soft { box-shadow: 0 14px 40px rgba(2,6,23,.08); }
          .ring-soft { box-shadow: 0 0 0 1px rgba(15,23,42,.06); }
        `}
            </style>

            {/* Header */}
            <header className="sticky top-0 z-50 border-b border-slate-100 bg-white/80 glass">
                <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                    <div className="flex h-16 items-center justify-between">
                        <Link to="/" className="flex items-center gap-2">
                            <div className="h-9 w-9 rounded-xl bg-slate-900"></div>
                            <span className="text-base font-semibold tracking-tight">Oye Creators</span>
                        </Link>

                        <nav className="hidden items-center gap-6 md:flex">
                            <Link className="text-sm font-medium text-slate-700 hover:text-slate-900" to="/product/discover-creators">Product</Link>
                            <Link className="text-sm font-medium text-slate-700 hover:text-slate-900" to="#">Customers</Link>
                            <Link className="text-sm font-medium text-slate-700 hover:text-slate-900" to="#">Resources</Link>
                            <Link className="text-sm font-medium text-slate-700 hover:text-slate-900" to="/pricing-page">Pricing</Link>
                        </nav>

                        <div className="hidden items-center gap-3 md:flex">
                            <Link to="/signin" className="rounded-xl px-4 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-50">Sign in</Link>
                            <a href="#cta" className="rounded-xl bg-slate-900 px-4 py-2 text-sm font-semibold text-white hover:bg-slate-800">
                                Request demo
                            </a>
                        </div>

                        <button
                            id="mobileBtn"
                            className="md:hidden rounded-xl border border-slate-200 px-3 py-2 text-sm font-semibold"
                            onClick={() => setMobileNavOpen(!mobileNavOpen)}
                        >
                            Menu
                        </button>
                    </div>

                    {/* Mobile Nav */}
                    {mobileNavOpen && (
                        <div id="mobileNav" className="border-t border-slate-100 py-4 md:hidden">
                            <div className="flex flex-col gap-2">
                                <Link className="rounded-xl px-3 py-2 text-sm font-medium hover:bg-slate-50" to="/product/discover-creators">Product</Link>
                                <Link className="rounded-xl px-3 py-2 text-sm font-medium hover:bg-slate-50" to="#">Customers</Link>
                                <Link className="rounded-xl px-3 py-2 text-sm font-medium hover:bg-slate-50" to="#">Resources</Link>
                                <Link className="rounded-xl px-3 py-2 text-sm font-medium hover:bg-slate-50" to="/pricing-page">Pricing</Link>
                                <div className="mt-2 flex gap-2">
                                    <Link to="/signin" className="w-1/2 rounded-xl border border-slate-200 px-4 py-2 text-center text-sm font-semibold">Sign in</Link>
                                    <a href="#cta" className="w-1/2 rounded-xl bg-slate-900 px-4 py-2 text-center text-sm font-semibold text-white">Request demo</a>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </header>

            {/* Sub-nav (Campaign Management) */}
            <section className="border-b border-slate-100 bg-white">
                <div className="mx-auto max-w-7xl px-4 py-4 sm:px-6 lg:px-8">
                    <div className="flex flex-wrap items-center gap-3 text-sm">
                        <span className="rounded-full bg-slate-100 px-3 py-1 font-semibold text-slate-700">Campaign Management</span>
                        <Link className="font-semibold text-slate-900" to="/product/media-plans">Media Plans</Link>
                        <Link className="text-slate-600 hover:text-slate-900" to="/product/manage-campaigns">Outreach</Link>
                        <Link className="text-slate-600 hover:text-slate-900" to="#">Execution</Link>
                        <Link className="text-slate-600 hover:text-slate-900" to="#">Reporting</Link>
                    </div>
                </div>
            </section>

            {/* Hero */}
            <section className="relative">
                <div className="mx-auto max-w-7xl px-4 pb-10 pt-12 sm:px-6 lg:px-8 lg:pb-16 lg:pt-16">
                    <div className="grid items-center gap-10 lg:grid-cols-2">
                        <div>
                            <div className="inline-flex items-center rounded-full border border-slate-200 bg-white px-4 py-2 text-xs font-semibold text-slate-700">
                                Media Plans • Hyperlocal Campaign Planning
                            </div>

                            <h1 className="mt-4 text-4xl font-semibold tracking-tight sm:text-5xl">
                                Build a hyperlocal media plan that clients can approve in minutes
                            </h1>

                            <p className="mt-4 text-base leading-relaxed text-slate-600 sm:text-lg">
                                Create a presentation-ready plan for your upcoming creator campaign—by city, locality, and platform.
                                Add creators, define deliverables and budgets, and get instant KPI estimates aligned to your outcomes.
                            </p>

                            <div className="mt-7 flex flex-col gap-3 sm:flex-row">
                                <a href="#build" className="rounded-2xl bg-slate-900 px-6 py-3 text-sm font-semibold text-white hover:bg-slate-800 text-center">
                                    Create media plan
                                </a>
                                <a href="#cta" className="rounded-2xl border border-slate-200 px-6 py-3 text-sm font-semibold text-slate-800 hover:bg-slate-50 text-center">
                                    Request demo
                                </a>
                            </div>

                            <div className="mt-8 flex flex-wrap items-center gap-3 text-xs text-slate-500">
                                <span className="rounded-full border border-slate-200 px-3 py-1">City & locality clusters</span>
                                <span className="rounded-full border border-slate-200 px-3 py-1">Nano & micro scale</span>
                                <span className="rounded-full border border-slate-200 px-3 py-1">KPI estimates</span>
                                <span className="rounded-full border border-slate-200 px-3 py-1">Client approval link</span>
                            </div>

                            <div className="mt-6 rounded-2xl border border-amber-200 bg-amber-50 px-4 py-3 text-xs text-amber-900">
                                KPI estimates are directional and depend on creator selection, platform performance variability, posting schedules, and market conditions.
                            </div>
                        </div>

                        <div>
                            <div className="aspect-[4/3] w-full rounded-3xl bg-slate-100 shadow-soft"></div>
                            <p className="mt-3 text-xs text-slate-500">
                                Replace with screenshot: “Media Plan table + locality split + KPI cards + approval panel”.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Intro card */}
            <section id="build" className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
                <div className="rounded-3xl border border-slate-100 bg-white p-6 shadow-soft lg:p-10">
                    <div className="flex flex-col items-start justify-between gap-6 lg:flex-row lg:items-center">
                        <div>
                            <h2 className="text-2xl font-semibold tracking-tight">Media Plans that match how hyperlocal campaigns are sold</h2>
                            <p className="mt-2 text-slate-600">
                                Most influencer briefs fail because they stay generic. Oye Creators Media Plans are designed for
                                locality-based execution—so budgets, creator mix, and expected outcomes stay clear.
                            </p>
                        </div>
                        <a href="#plan-features" className="rounded-2xl bg-slate-900 px-6 py-3 text-sm font-semibold text-white hover:bg-slate-800">
                            Explore features
                        </a>
                    </div>
                </div>
            </section>

            {/* Feature Sections */}
            <section id="plan-features" className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
                <div className="grid gap-6 lg:gap-8">
                    <div className="text-center">
                        <h2 className="text-3xl font-semibold tracking-tight">Media Plan features for effective campaign planning</h2>
                        <p className="mx-auto mt-3 max-w-3xl text-slate-600">
                            Create a plan your client can understand instantly—creator mix, deliverables, budget split, and KPIs—without spreadsheets.
                        </p>
                    </div>

                    {/* Feature 1 */}
                    <div className="grid items-center gap-6 rounded-3xl border border-slate-100 bg-white p-6 shadow-soft lg:grid-cols-2 lg:p-10">
                        <div>
                            <div className="text-xs font-semibold uppercase tracking-wider text-slate-500">Step 1 • Setup</div>
                            <h3 className="mt-2 text-xl font-semibold tracking-tight">Create a plan by city clusters, platforms, and currency</h3>
                            <p className="mt-3 text-slate-600">
                                Define your target geography (city/locality clusters), choose platforms (Instagram, YouTube, Facebook, X, LinkedIn),
                                and set currency + tax assumptions. Brand the plan with your logo so it is client-ready.
                            </p>

                            <div className="mt-4 grid gap-3 sm:grid-cols-2">
                                <div className="rounded-2xl border border-slate-100 bg-slate-50 p-4">
                                    <div className="text-xs font-semibold uppercase tracking-wider text-slate-500">Inputs</div>
                                    <ul className="mt-2 space-y-2 text-sm text-slate-700">
                                        <li className="flex gap-3"><span className="mt-1 h-2 w-2 rounded-full bg-slate-900"></span>City clusters (e.g., Pune • PCMC)</li>
                                        <li className="flex gap-3"><span className="mt-1 h-2 w-2 rounded-full bg-slate-900"></span>Localities (Baner, Wakad, Aundh…)</li>
                                        <li className="flex gap-3"><span className="mt-1 h-2 w-2 rounded-full bg-slate-900"></span>Platform mix + timeline</li>
                                    </ul>
                                </div>
                                <div className="rounded-2xl border border-slate-100 bg-slate-50 p-4">
                                    <div className="text-xs font-semibold uppercase tracking-wider text-slate-500">Outputs</div>
                                    <ul className="mt-2 space-y-2 text-sm text-slate-700">
                                        <li className="flex gap-3"><span className="mt-1 h-2 w-2 rounded-full bg-slate-900"></span>Locality-wise budget plan</li>
                                        <li className="flex gap-3"><span className="mt-1 h-2 w-2 rounded-full bg-slate-900"></span>Creator mix by tier</li>
                                        <li className="flex gap-3"><span className="mt-1 h-2 w-2 rounded-full bg-slate-900"></span>Deliverables grid</li>
                                    </ul>
                                </div>
                            </div>

                            <a href="#cta" className="mt-5 inline-flex items-center rounded-2xl bg-slate-900 px-5 py-3 text-sm font-semibold text-white hover:bg-slate-800">
                                Create a branded plan
                            </a>
                        </div>
                        <div>
                            <div className="aspect-[4/3] w-full rounded-3xl bg-slate-100"></div>
                        </div>
                    </div>

                    {/* Feature 2 */}
                    <div className="grid items-center gap-6 rounded-3xl border border-slate-100 bg-white p-6 shadow-soft lg:grid-cols-2 lg:p-10">
                        <div className="order-2 lg:order-1">
                            <div className="aspect-[4/3] w-full rounded-3xl bg-slate-100"></div>
                        </div>
                        <div className="order-1 lg:order-2">
                            <div className="text-xs font-semibold uppercase tracking-wider text-slate-500">Step 2 • Creator lineup</div>
                            <h3 className="mt-2 text-xl font-semibold tracking-tight">Keep all creator details, commercials, and deliverables in one plan</h3>
                            <p className="mt-3 text-slate-600">
                                Add creators from your Discovery/shortlists. Record deliverables per creator (Reels, Shorts, Stories, Posts),
                                payout, expected timeline, and any notes that Ops and Servicing need.
                            </p>

                            <div className="mt-4 rounded-2xl border border-slate-100 bg-slate-50 p-4">
                                <div className="text-sm font-semibold">Designed for real campaign execution</div>
                                <p className="mt-2 text-sm text-slate-700">
                                    The plan is not just a deck—it becomes your execution-ready source of truth for outreach, negotiation,
                                    scheduling, submissions, approvals, and posting.
                                </p>
                            </div>

                            <a href="#cta" className="mt-5 inline-flex items-center rounded-2xl bg-slate-900 px-5 py-3 text-sm font-semibold text-white hover:bg-slate-800">
                                Add creators to plan
                            </a>
                        </div>
                    </div>

                    {/* Feature 3 */}
                    <div className="grid items-center gap-6 rounded-3xl border border-slate-100 bg-white p-6 shadow-soft lg:grid-cols-2 lg:p-10">
                        <div>
                            <div className="text-xs font-semibold uppercase tracking-wider text-slate-500">Step 3 • KPI estimates</div>
                            <h3 className="mt-2 text-xl font-semibold tracking-tight">Get KPI estimates instantly—aligned to hyperlocal outcomes</h3>
                            <p className="mt-3 text-slate-600">
                                Estimate directional results based on your creator mix, deliverables, and budget.
                                Use a KPI set that matches local campaigns: Reach, Views, Engagement, Saves/Shares, and cost efficiency.
                            </p>

                            <div className="mt-4 grid gap-3 sm:grid-cols-2">
                                <div className="rounded-2xl border border-slate-100 bg-slate-50 p-4">
                                    <div className="text-xs font-semibold uppercase tracking-wider text-slate-500">Suggested KPIs</div>
                                    <ul className="mt-2 space-y-2 text-sm text-slate-700">
                                        <li className="flex gap-3"><span className="mt-1 h-2 w-2 rounded-full bg-slate-900"></span>Estimated Reach / Views</li>
                                        <li className="flex gap-3"><span className="mt-1 h-2 w-2 rounded-full bg-slate-900"></span>Engagement Rate (ER)</li>
                                        <li className="flex gap-3"><span className="mt-1 h-2 w-2 rounded-full bg-slate-900"></span>Cost per View (CPV) / Cost per Engagement (CPE)</li>
                                    </ul>
                                </div>
                                <div className="rounded-2xl border border-slate-100 bg-slate-50 p-4">
                                    <div className="text-xs font-semibold uppercase tracking-wider text-slate-500">Hyperlocal adds</div>
                                    <ul className="mt-2 space-y-2 text-sm text-slate-700">
                                        <li className="flex gap-3"><span className="mt-1 h-2 w-2 rounded-full bg-slate-900"></span>Locality coverage score</li>
                                        <li className="flex gap-3"><span className="mt-1 h-2 w-2 rounded-full bg-slate-900"></span>Creator density by locality</li>
                                        <li className="flex gap-3"><span className="mt-1 h-2 w-2 rounded-full bg-slate-900"></span>Weighted engagement (shares/saves > likes)</li>
                                    </ul>
                                </div>
                            </div>

                            <a href="#cta" className="mt-5 inline-flex items-center rounded-2xl bg-slate-900 px-5 py-3 text-sm font-semibold text-white hover:bg-slate-800">
                                See KPI calculation view
                            </a>
                        </div>
                        <div>
                            <div className="aspect-[4/3] w-full rounded-3xl bg-slate-100"></div>
                        </div>
                    </div>

                    {/* Feature 4 */}
                    <div className="grid items-center gap-6 rounded-3xl border border-slate-100 bg-white p-6 shadow-soft lg:grid-cols-2 lg:p-10">
                        <div className="order-2 lg:order-1">
                            <div className="aspect-[4/3] w-full rounded-3xl bg-slate-100"></div>
                        </div>
                        <div className="order-1 lg:order-2">
                            <div className="text-xs font-semibold uppercase tracking-wider text-slate-500">Step 4 • Client approval</div>
                            <h3 className="mt-2 text-xl font-semibold tracking-tight">Share a presentation-ready plan with clients</h3>
                            <p className="mt-3 text-slate-600">
                                Share a secure link for review. Control what the client can see—creator lineup, deliverables, and KPI estimates—
                                so approvals happen faster and misunderstandings drop.
                            </p>

                            <div className="mt-4 rounded-2xl border border-slate-100 bg-slate-50 p-4">
                                <div className="text-sm font-semibold">Recommended workflow</div>
                                <div className="mt-2 text-sm text-slate-700">
                                    Client approves → Ops initiates outreach → Negotiation → Confirmation → Scheduling → Submission review → Posting → Reporting.
                                </div>
                            </div>

                            <a href="#cta" className="mt-5 inline-flex items-center rounded-2xl bg-slate-900 px-5 py-3 text-sm font-semibold text-white hover:bg-slate-800">
                                Share approval link
                            </a>
                        </div>
                    </div>
                </div>
            </section>

            {/* Small “Smooth experience” list */}
            <section className="mx-auto max-w-7xl px-4 py-10 sm:px-6 lg:px-8">
                <div className="rounded-3xl border border-slate-100 bg-white p-6 shadow-soft lg:p-10">
                    <h2 className="text-2xl font-semibold tracking-tight">Smooth experience and simple hyperlocal planning</h2>
                    <p className="mt-2 text-slate-600">
                        Built for teams running 50–1000+ creator activations across multiple localities.
                    </p>

                    <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
                        <div className="rounded-2xl border border-slate-100 p-5">
                            <div className="text-xs font-semibold uppercase tracking-wider text-slate-500">Add creators fast</div>
                            <div className="mt-2 text-sm font-semibold">Add creators from discovery and shortlists</div>
                            <p className="mt-2 text-sm text-slate-600">Bring creators into your plan without manual spreadsheets.</p>
                        </div>
                        <div className="rounded-2xl border border-slate-100 p-5">
                            <div className="text-xs font-semibold uppercase tracking-wider text-slate-500">Tier mix</div>
                            <div className="mt-2 text-sm font-semibold">Plan by nano / mini-micro / micro tiers</div>
                            <p className="mt-2 text-sm text-slate-600">Set deliverables and budgets by tier to control cost and reach.</p>
                        </div>
                        <div className="rounded-2xl border border-slate-100 p-5">
                            <div className="text-xs font-semibold uppercase tracking-wider text-slate-500">Locality coverage</div>
                            <div className="mt-2 text-sm font-semibold">Ensure coverage across city pockets</div>
                            <p className="mt-2 text-sm text-slate-600">Avoid over-indexing on one locality; maintain a balanced spread.</p>
                        </div>
                        <div className="rounded-2xl border border-slate-100 p-5">
                            <div className="text-xs font-semibold uppercase tracking-wider text-slate-500">KPI clarity</div>
                            <div className="mt-2 text-sm font-semibold">Directional KPI estimates</div>
                            <p className="mt-2 text-sm text-slate-600">Use a consistent KPI model to compare options before execution.</p>
                        </div>
                        <div className="rounded-2xl border border-slate-100 p-5">
                            <div className="text-xs font-semibold uppercase tracking-wider text-slate-500">Client-ready</div>
                            <div className="mt-2 text-sm font-semibold">Presentation-ready output</div>
                            <p className="mt-2 text-sm text-slate-600">Share a clean view that clients can understand and approve.</p>
                        </div>
                        <div className="rounded-2xl border border-slate-100 p-5">
                            <div className="text-xs font-semibold uppercase tracking-wider text-slate-500">Execution bridge</div>
                            <div class="mt-2 text-sm font-semibold">Plan converts into execution workflows</div>
                            <p className="mt-2 text-sm text-slate-600">Move from planning to outreach and delivery without rework.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* FAQ */}
            <section className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
                <div className="rounded-3xl border border-slate-100 bg-white p-6 shadow-soft lg:p-10">
                    <h2 className="text-2xl font-semibold tracking-tight">Questions and Answers about Media Plans</h2>

                    <div className="mt-6 divide-y divide-slate-100">
                        <details className="group py-4" open>
                            <summary className="flex cursor-pointer list-none items-center justify-between text-sm font-semibold">
                                What is a media plan in Oye Creators?
                                <span className="text-slate-400 group-open:rotate-180 transition">▾</span>
                            </summary>
                            <p className="mt-3 text-sm text-slate-600">
                                A media plan is a structured campaign blueprint: city/locality coverage, creator mix, deliverables, budgets,
                                and directional KPIs. It is designed to be client-approvable and execution-ready.
                            </p>
                        </details>

                        <details className="group py-4">
                            <summary className="flex cursor-pointer list-none items-center justify-between text-sm font-semibold">
                                Which KPIs should I include for hyperlocal creator campaigns?
                                <span class="text-slate-400 group-open:rotate-180 transition">▾</span>
                            </summary>
                            <p className="mt-3 text-sm text-slate-600">
                                Most hyperlocal campaigns track reach/views plus a weighted engagement set (shares/saves/comments weighted above likes),
                                and cost efficiency (CPV/CPE). For outlet-based campaigns, add locality coverage and conversion proxy signals (DMs/clicks/calls if available).
                            </p>
                        </details>

                        <details className="group py-4">
                            <summary className="flex cursor-pointer list-none items-center justify-between text-sm font-semibold">
                                Can I plan across Instagram, YouTube, Facebook, X, LinkedIn?
                                <span class="text-slate-400 group-open:rotate-180 transition">▾</span>
                            </summary>
                            <p className="mt-3 text-sm text-slate-600">
                                Yes—structure the plan by platform and deliverable type. Actual reporting depth depends on platform policies and your configured integrations.
                            </p>
                        </details>

                        <details className="group py-4">
                            <summary className="flex cursor-pointer list-none items-center justify-between text-sm font-semibold">
                                How does client approval work?
                                <span class="text-slate-400 group-open:rotate-180 transition">▾</span>
                            </summary>
                            <p className="mt-3 text-sm text-slate-600">
                                Share a plan link. Choose what the client can view (creator list, deliverables, budgets, KPIs).
                                Use approvals to lock scope before outreach begins.
                            </p>
                        </details>

                        <details className="group py-4">
                            <summary className="flex cursor-pointer list-none items-center justify-between text-sm font-semibold">
                                How does the media plan connect to outreach and execution?
                                <span class="text-slate-400 group-open:rotate-180 transition">▾</span>
                            </summary>
                            <p className="mt-3 text-sm text-slate-600">
                                Once a plan is approved, Ops can start outreach with the same creator lineup and terms, negotiate within approved ranges,
                                confirm creators, schedule shoots, collect drafts, and manage revisions—without rebuilding the plan in another tool.
                            </p>
                        </details>
                    </div>
                </div>
            </section>

            {/* CTA + Logo strip */}
            <section id="cta" className="mx-auto max-w-7xl px-4 py-10 sm:px-6 lg:px-8">
                <div className="grid gap-6 lg:grid-cols-2">
                    <div className="rounded-3xl border border-slate-100 bg-white p-6 shadow-soft lg:p-10">
                        <h3 className="text-xl font-semibold tracking-tight">See Oye Creators Media Plans in action</h3>
                        <p className="mt-2 text-slate-600">
                            We will set up a sample plan using your city clusters, campaign objective, and creator tier mix—then walk you through approvals and execution flow.
                        </p>
                        <button className="mt-5 inline-flex items-center rounded-2xl bg-slate-900 px-6 py-3 text-sm font-semibold text-white hover:bg-slate-800 border-none cursor-pointer">
                            Request demo
                        </button>
                    </div>

                    <div className="rounded-3xl bg-slate-900 p-6 text-white shadow-soft lg:p-10">
                        <h3 className="text-xl font-semibold tracking-tight">Start with a pilot plan</h3>
                        <p className="mt-2 text-white/80">
                            Build one plan for one city cluster, get client approval, and scale to more localities once the KPI model is validated.
                        </p>
                        <button className="mt-5 inline-flex items-center rounded-2xl bg-white px-6 py-3 text-sm font-semibold text-slate-900 hover:bg-slate-100 border-none cursor-pointer">
                            Create media plan
                        </button>
                    </div>
                </div>

                <div className="mt-10 rounded-3xl border border-slate-100 bg-white p-6 shadow-soft lg:p-10">
                    <p className="text-center text-sm font-semibold text-slate-700">
                        Trusted by teams running high-volume hyperlocal creator campaigns
                    </p>
                    <div className="mt-5 grid grid-cols-2 gap-4 sm:grid-cols-4 lg:grid-cols-8">
                        <div className="h-10 rounded-xl bg-slate-100"></div>
                        <div className="h-10 rounded-xl bg-slate-100"></div>
                        <div className="h-10 rounded-xl bg-slate-100"></div>
                        <div className="h-10 rounded-xl bg-slate-100"></div>
                        <div className="h-10 rounded-xl bg-slate-100"></div>
                        <div className="h-10 rounded-xl bg-slate-100"></div>
                        <div className="h-10 rounded-xl bg-slate-100"></div>
                        <div className="h-10 rounded-xl bg-slate-100"></div>
                    </div>
                </div>
            </section>

            {/* Footer */}
            <footer className="border-t border-slate-100">
                <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
                    <div className="grid gap-10 md:grid-cols-4">
                        <div>
                            <div className="flex items-center gap-2">
                                <div className="h-9 w-9 rounded-xl bg-slate-900"></div>
                                <div className="text-base font-semibold">Oye Creators</div>
                            </div>
                            <p className="mt-3 text-sm text-slate-600">
                                Hyperlocal creator campaigns with measurable outcomes—powered by data.
                            </p>
                        </div>

                        <div>
                            <div className="text-sm font-semibold">Product</div>
                            <ul className="mt-3 space-y-2 text-sm text-slate-600">
                                <li><Link className="hover:text-slate-900" to="/product/discover-creators">Discovery</Link></li>
                                <li><Link className="hover:text-slate-900" to="/product/media-analytics">Market Analysis</Link></li>
                                <li><Link className="hover:text-slate-900" to="/product/media-plans">Media Plans</Link></li>
                                <li><Link className="hover:text-slate-900" to="/product/manage-campaigns">Outreach</Link></li>
                                <li><Link className="hover:text-slate-900" to="#">Reporting</Link></li>
                            </ul>
                        </div>

                        <div>
                            <div className="text-sm font-semibold">Company</div>
                            <ul className="mt-3 space-y-2 text-sm text-slate-600">
                                <li><Link className="hover:text-slate-900" to="#">About</Link></li>
                                <li><Link className="hover:text-slate-900" to="/contact">Contact</Link></li>
                                <li><Link className="hover:text-slate-900" to="/jobs">Careers</Link></li>
                            </ul>
                        </div>

                        <div>
                            <div className="text-sm font-semibold">Legal</div>
                            <ul className="mt-3 space-y-2 text-sm text-slate-600">
                                <li><Link className="hover:text-slate-900" to="/terms-of-service">Terms</Link></li>
                                <li><Link className="hover:text-slate-900" to="/privacy-policy">Privacy</Link></li>
                                <li><Link className="hover:text-slate-900" to="/cookies-and-ip">Cookie Policy</Link></li>
                            </ul>
                        </div>
                    </div>

                    <div className="mt-10 text-xs text-slate-500">
                        © <span id="year">{new Date().getFullYear()}</span> Oye Creators. All rights reserved.
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default MediaPlans;
